import { ApexOptions } from 'apexcharts';
import capitalize from 'lodash/capitalize';
import lowerCase from 'lodash/lowerCase';
import { renderToString } from 'react-dom/server';
import BalanceBarChart from '@/modules/common/components/BalanceBarChart.tsx';
import { useGetCommunicationPreferencesQuery } from '@/modules/issuer-dashboard/queries/charts.ts';
import { InfoCard, Spinner } from 'ui';
import { goodFormatNumber } from 'ui/utils';

const formatInvestors = (total: number) => {
  return `${goodFormatNumber(total)} investors`;
};

const investorsChartOptions: ApexOptions = {
  tooltip: {
    custom: ({ seriesIndex, series, w }) => {
      const label = capitalize(lowerCase(w.config.series[seriesIndex]?.name || ''));
      return renderToString(
        <div className="p-2">
          {label}: {series[seriesIndex]} investors
        </div>,
      );
    },
  },
};

const CommunicationPreference = () => {
  const { data, isLoading } = useGetCommunicationPreferencesQuery();

  return (
    <InfoCard title="Holder Communication Preference">
      {isLoading && <Spinner />}
      {!isLoading && !data && <div>No data</div>}
      {!isLoading && data && (
        <BalanceBarChart
          data={data?.data as any}
          formatTotal={formatInvestors}
          options={investorsChartOptions}
        />
      )}
    </InfoCard>
  );
};

export default CommunicationPreference;
